import script from "./ProposalRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalRow.vue?vue&type=script&setup=true&lang=js"

import "./ProposalRow.vue?vue&type=style&index=0&id=30775438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30775438"]])

export default __exports__